export class UpdateAccountProfileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccount",
            "baseName": "eonAccount",
            "type": "EonAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAccountProfileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
